export const getAuthToken = () => localStorage.getItem('token');

export const handleLogout = (navigate) => {
  localStorage.removeItem('token');
  localStorage.removeItem('artist');
  navigate('/login');
};
